<template>
  <div id="app" class="min-h-screen flex flex-col custom-background">
    <dark-nav></dark-nav>
    <div class="flex-grow mobstyle px-4 sm:px-6 lg:px-12 xl:px-0" id="main">
      <flash-message></flash-message>
      <main>
        <router-view />
      </main>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { auth } from "./utils/firebase";
import DarkNav from "./components/DarkNav";
import Footer from "./components/Footer";
import FlashMessage from "./components/FlashMessage";
export default {
  data() {
    return {};
  },
  computed: {
    ...mapGetters({
      user: "user"
    }),
    displayName() {
      if (auth.currentUser) {
        return auth.currentUser.displayName;
      } else {
        return "Not logged in";
      }
    }
  },
  methods: {
    signOut() {
      auth.signOut();
    }
  },
  components: {
    FlashMessage,
    DarkNav,
    Footer
  }
};
</script>
<style scoped>
.custom-background {
  background: rgb(229, 229, 229);
  background: -moz-linear-gradient(0deg, rgba(229,229,229,1) 5%, rgba(207,207,207,1) 53%, rgba(255,255,255,1) 100%);
  background: -webkit-linear-gradient(0deg, rgba(229,229,229,1) 5%, rgba(207,207,207,1) 53%, rgba(255,255,255,1) 100%);
  background: linear-gradient(0deg, rgba(229,229,229,1) 5%, rgba(207,207,207,1) 53%, rgba(255,255,255,1) 100%);
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#e5e5e5",endColorstr="#ffffff",GradientType=1);

  background: rgb(229, 231, 235);

  background-image: url("/images/square-bg.png");
}

.mobstyle:has(.home) { padding-left: 0; padding-right: 0; }

</style>
